export function validateFormContact({ email, content }) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(email)) return false;
  if (!content || content.length > 5000) return false;
  return true;
}
